exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3YxaYxaqNEfY_9{background-color:#fafcfc;border-radius:3px;height:20px;width:20px}._1Vt95gVlq7grHx,._3YxaYxaqNEfY_9{box-shadow:inset 0 0 0 2px #dfe3e6}._1Vt95gVlq7grHx{background-color:#f5f6f7}._3RSHfL1qzdNdWw{background-color:#ebeef0;box-shadow:inset 0 0 0 2px #dfe3e6}._2sgAFiSXcQxi8m{background-color:#17394d;box-shadow:inset 0 0 0 2px #17394d}.jt2lKzFKbJduL4{background-color:#fff;box-shadow:none}._2GnYWqhEgnfuwL{background-color:#ebeef0;box-shadow:none}._36ft1IcbnYDoy7{background-color:#c2ccd1;box-shadow:none}._2oi7Av_pmSUB9M{word-break:break-word;word-wrap:break-word;overflow-wrap:break-word}._2oi7Av_pmSUB9M h1{font-size:24px;line-height:28px;margin:0 0 12px}._2oi7Av_pmSUB9M h2{font-size:20px;line-height:24px;margin:0 0 8px}._2oi7Av_pmSUB9M h3,._2oi7Av_pmSUB9M h4,._2oi7Av_pmSUB9M h5,._2oi7Av_pmSUB9M h6{font-size:16px;line-height:20px;margin:0 0 8px}._2oi7Av_pmSUB9M hr{background:#d6dadc;border:0;color:#d6dadc;height:1px;margin:16px 0;padding:0;width:100%}._2oi7Av_pmSUB9M a{color:#444}._2oi7Av_pmSUB9M a:hover{color:#111}._2oi7Av_pmSUB9M a._3huGXmjCgL6gmj,._2oi7Av_pmSUB9M a._3huGXmjCgL6gmj:hover{color:#6b808c;cursor:default;text-decoration:none}._2oi7Av_pmSUB9M p{margin:0 0 8px}._2oi7Av_pmSUB9M div::selection{background:transparent}._2oi7Av_pmSUB9M pre{-webkit-overflow-scrolling:touch;-webkit-transform:translateZ(0);background-color:#f8f9f9;border-radius:3px;box-shadow:inset 0 0 0 1px #d6dadc;margin:12px 0;padding:8px 12px;word-break:normal;word-wrap:normal;overflow-wrap:normal}._2oi7Av_pmSUB9M pre::-webkit-scrollbar{height:8px;width:8px}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-button:end:increment,._2oi7Av_pmSUB9M pre::-webkit-scrollbar-button:start:decrement{background:transparent;display:none}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-track-piece{background:rgba(9,45,66,.08)}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-track-piece:vertical:start{border-radius:4px 4px 0 0}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-track-piece:vertical:end{border-radius:0 0 4px 4px}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-track-piece:horizontal:start{border-radius:4px 0 0 4px}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-track-piece:horizontal:end{border-radius:0 4px 4px 0}._2oi7Av_pmSUB9M pre::-webkit-scrollbar-thumb:horizontal,._2oi7Av_pmSUB9M pre::-webkit-scrollbar-thumb:vertical{background:rgba(9,45,66,.13);border-radius:4px;display:block;height:48px}._2oi7Av_pmSUB9M pre:after{clear:both;content:\"\";display:table}._2oi7Av_pmSUB9M code{background-color:#f8f9f9;border-radius:3px;box-shadow:0 0 0 1px #d6dadc;color:#eb5a46;padding:1px 3px;margin:-1px 2px}._2oi7Av_pmSUB9M pre code{background-color:none;border-radius:0;box-shadow:none;color:#17394d;margin:0;padding:0}._2oi7Av_pmSUB9M code,._2oi7Av_pmSUB9M pre,._2oi7Av_pmSUB9M tt{font-family:bitstream vera sans mono,andale mono,lucida console,Ubuntu Mono,Menlo,Courier,monospace;line-height:20px}._2oi7Av_pmSUB9M blockquote{border-left:1px solid #cdd2d4;color:#6b808c;margin:12px 0 12px 11px;padding:0 0 0 12px}._2oi7Av_pmSUB9M ol,._2oi7Av_pmSUB9M ul{list-style:none;margin:0;padding:0;margin:8px 0}._2oi7Av_pmSUB9M ul>li{list-style:disc;margin:8px 8px 8px 24px}._2oi7Av_pmSUB9M ol>li{list-style:decimal;margin:8px 8px 8px 24px}._2oi7Av_pmSUB9M ol>li ul>li,._2oi7Av_pmSUB9M ul>li ul>li{list-style:circle}._2oi7Av_pmSUB9M ol>li ol>li,._2oi7Av_pmSUB9M ul>li ol>li{list-style:lower-roman}", ""]);

// exports
exports.locals = {
	"N0": "#FFFFFF",
	"N10": "#FAFCFC",
	"N20": "#F5F6F7",
	"N30": "#EBEEF0",
	"N40": "#DFE3E6",
	"N50": "#C2CCD1",
	"N60": "#B3BEC4",
	"N70": "#A6B3BA",
	"N80": "#97A7B0",
	"N90": "#899AA3",
	"N100": "#798D99",
	"N200": "#6B808C",
	"N300": "#5E7785",
	"N400": "#516B7A",
	"N500": "#425E6E",
	"N600": "#355263",
	"N700": "#254659",
	"N800": "#17394D",
	"N900": "#092D42",
	"N10A": "rgba(9, 45, 66, 0.02)",
	"N20A": "rgba(9, 45, 66, 0.04)",
	"N30A": "rgba(9, 45, 66, 0.08)",
	"N40A": "rgba(9, 45, 66, 0.13)",
	"N50A": "rgba(9, 45, 66, 0.25)",
	"N60A": "rgba(9, 45, 66, 0.31)",
	"N70A": "rgba(9, 45, 66, 0.36)",
	"N80A": "rgba(9, 45, 66, 0.42)",
	"N90A": "rgba(9, 45, 66, 0.48)",
	"N100A": "rgba(9, 45, 66, 0.54)",
	"N200A": "rgba(9, 45, 66, 0.6)",
	"N300A": "rgba(9, 45, 66, 0.66)",
	"N400A": "rgba(9, 45, 66, 0.71)",
	"N500A": "rgba(9, 45, 66, 0.77)",
	"N600A": "rgba(9, 45, 66, 0.82)",
	"N700A": "rgba(9, 45, 66, 0.89)",
	"N800A": "rgba(9, 45, 66, 0.95)",
	"trello-blue-50": "#E4F0F6",
	"trello-blue-100": "#BCD9EA",
	"trello-blue-200": "#8BBDD9",
	"trello-blue-300": "#5BA4CF",
	"trello-blue-400": "#298FCA",
	"trello-blue-500": "#0079BF",
	"trello-blue-600": "#026AA7",
	"trello-blue-700": "#055A8C",
	"trello-blue-800": "#094C72",
	"trello-blue-900": "#0C3953",
	"green-50": "#EEF6EC",
	"green-100": "#D6ECD2",
	"green-200": "#B7DDB0",
	"green-300": "#99D18F",
	"green-400": "#7BC86C",
	"green-500": "#61BD4F",
	"green-600": "#5AAC44",
	"green-700": "#519839",
	"green-800": "#49852E",
	"green-900": "#3F6F21",
	"orange-50": "#FDF4E7",
	"orange-100": "#FCE6C6",
	"orange-200": "#FAD29C",
	"orange-300": "#FDBF69",
	"orange-400": "#FFAF3F",
	"orange-500": "#FF9F1A",
	"orange-600": "#E79217",
	"orange-700": "#CD8313",
	"orange-800": "#B4760F",
	"orange-900": "#96650A",
	"red-50": "#FBEDEB",
	"red-100": "#F5D3CE",
	"red-200": "#EFB3AB",
	"red-300": "#EC9488",
	"red-400": "#EF7564",
	"red-500": "#EB5A46",
	"red-600": "#CF513D",
	"red-700": "#B04632",
	"red-800": "#933B27",
	"red-900": "#6E2F1A",
	"yellow-50": "#FDFAE5",
	"yellow-100": "#FAF3C0",
	"yellow-200": "#F5EA92",
	"yellow-300": "#F3E260",
	"yellow-400": "#F5DD29",
	"yellow-500": "#F2D600",
	"yellow-600": "#E6C60D",
	"yellow-700": "#D9B51C",
	"yellow-800": "#CCA42B",
	"yellow-900": "#BD903C",
	"purple-50": "#F7F0FA",
	"purple-100": "#EDDBF4",
	"purple-200": "#DFC0EB",
	"purple-300": "#D5A6E6",
	"purple-400": "#CD8DE5",
	"purple-500": "#C377E0",
	"purple-600": "#A86CC1",
	"purple-700": "#89609E",
	"purple-800": "#6C547B",
	"purple-900": "#484553",
	"pink-50": "#FEF1F9",
	"pink-100": "#FCDCEF",
	"pink-200": "#F9C2E4",
	"pink-300": "#FFABDF",
	"pink-400": "#FF8ED4",
	"pink-500": "#FF78CB",
	"pink-600": "#E568AF",
	"pink-700": "#C9558F",
	"pink-800": "#AE4270",
	"pink-900": "#8E2D4B",
	"sky-50": "#E4F7FA",
	"sky-100": "#BDECF3",
	"sky-200": "#8FDFEB",
	"sky-300": "#5DD3E5",
	"sky-400": "#29CCE5",
	"sky-500": "#00C2E0",
	"sky-600": "#00AECC",
	"sky-700": "#0098B7",
	"sky-800": "#0082A0",
	"sky-900": "#006988",
	"lime-50": "#ECFBF3",
	"lime-100": "#D3F6E4",
	"lime-200": "#B3F1D0",
	"lime-300": "#90ECC1",
	"lime-400": "#6DECA9",
	"lime-500": "#51E898",
	"lime-600": "#4ED583",
	"lime-700": "#4BBF6B",
	"lime-800": "#49AA54",
	"lime-900": "#459139",
	"business-blue-50": "#EDEFF4",
	"business-blue-100": "#D2D7E5",
	"business-blue-200": "#B2B9D0",
	"business-blue-300": "#838FB5",
	"business-blue-400": "#6170A1",
	"business-blue-500": "#42548E",
	"business-blue-600": "#3E4D80",
	"business-blue-700": "#3A476F",
	"business-blue-900": "#30364C",
	"business-blue-800": "#36405F",
	"blue-500": "#0079BF",
	"black": "#000",
	"black-500": "#4d4d4d",
	"near-black": "#4d4d4d",
	"white": "#FFFFFF",
	"m-badge-toggle-default": "_3YxaYxaqNEfY_9",
	"m-badge-toggle-off-idle": "_1Vt95gVlq7grHx",
	"m-badge-toggle-off-hover": "_3RSHfL1qzdNdWw",
	"m-badge-toggle-off-active": "_2sgAFiSXcQxi8m",
	"m-badge-toggle-on-idle": "jt2lKzFKbJduL4",
	"m-badge-toggle-on-hover": "_2GnYWqhEgnfuwL",
	"m-badge-toggle-on-active": "_36ft1IcbnYDoy7",
	"markdown": "_2oi7Av_pmSUB9M",
	"disabled": "_3huGXmjCgL6gmj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2936/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/trello-markdown/trello-markdown.less
// module id = zhDR
// module chunks = 13